<template>
  <rb-popup
    v-model="model"
    @confirm="handleConfirm"
    @cancel="handleTerms"
    confirm-text="Contratar"
    cancel-text="Termos de uso"
    auxiliar-text="Cancelar"
    :close-on="['confirm', 'auxiliar', 'exit']"
    :show-auxiliar="true"
    auxiliar-color="#505353"
    confirm-color="primary-60"
    cancel-color="primary-35"
    variant-cancel="outlined"
    variant-auxiliar="outlined"
    width="600"
    :button-styles="{
      cancel: { borderColor: '#c5c7c6' },
      auxiliar: { borderColor: '#c5c7c6' }
    }"
    title-class="d-flex px-8 mt-4 justify-end align-center"
    message-class="popup-card-text d-flex flex-column align-start pt-0 ga-4"
    :disabled-confirm="!user?.superadmin"
    :confirm-tooltip-text="!user?.superadmin ? 'Você precisa ter permissões de superadministrador para contratar' : ''"
  >
    <template #title>
      <span></span>
    </template>

    <template #message>
      <div class="insights-popup-content">
        <img :src="require('@/ai_studio/assets/icons/insights-logo.svg')" alt="" />

        <p class="insights-popup-description">
          Preveja a probabilidade de matrícula com precisão. Tome decisões baseadas
          em dados e tendências.
          <a
            target="_blank"
            href="https://rubeus.com.br/"
            @click="sendInteraction('interested')"
          >
            Saiba mais.
          </a>
        </p>

        <div>
          <div class="insights-popup-highlight">
            30 dias de teste gratuito
          </div>
  
          <p class="insights-popup-subtitle">
            após o período de testes, R$ 300,00/mês
          </p>
        </div>

        <div class="insights-popup-feature">
          <v-icon size="16" class="feature-icon">mdi-chart-bar</v-icon>
          <span>Plano com até 12 mil análises/ano.</span>
        </div>

        <div class="insights-popup-feature">
          <v-icon size="16" class="feature-icon">mdi-phone-outline</v-icon>
          <span>
            Para mais informações,
            <a
              target="_blank"
              href="https://rubeus.com.br/"
              @click="sendInteraction('interested')"
            >
              fale com um consultor.
            </a>
          </span>
        </div>
      </div>
    </template>
  </rb-popup>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';
import axios from 'axios';
import RbPopup from '@/ai_studio/components/common/RBPopup.vue';
import { useUserStore } from '@/ai_studio/stores/user';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue', 'hired']);

const userStore = useUserStore();
const user = computed(() => userStore.data);

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const handleConfirm = async () => {
  try {
    await axios.get('/api/assistents/resources/hire-insights');
    await sendInteraction('contracted');
    emit('hired');
  } catch (error) {
    console.error(error);
  }
};

const handleTerms = () => {
  window.open('https://rbarquivos.apprbs.com.br/aistudio/termosdeuso.pdf', '_blank');
};

const sendInteraction = async (interaction_type) => {
  try {
    await axios.post('/api/assistents/resources/send-interaction', {
      interaction_type,
      product: 'insights'
    });
  } catch (error) {
    console.error(error);
  }
};
</script>

<style scoped lang="scss">
.hiring-popup-text {
  font-size: 14px;
  color: rgb(var(--v-theme-neutral-15));
  text-align: start;

  a {
    font-weight: 700;
    text-decoration: none;
    color: rgb(var(--v-theme-primary-60));
  }
}

.popup-list {
  padding: 0;
  background: transparent;
}

.popup-list-item {
  padding-left: 0 !important;
  padding-right: 0 !important;
  min-height: auto !important;
  align-items: center;

  .v-list-item-title {
    font-size: 14px !important;
    color: rgb(var(--v-theme-neutral-15)) !important;
    text-align: start !important;
    line-height: 20px;
    font-weight: 400;
    white-space: normal;
  }

  .v-list-item__prepend {
    img {
      margin-right: 4px !important;
      width: 20px;
      height: 20px;
    }
  }
}

.insights-popup-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 18px;
  max-width: 620px;
  margin: 0 auto;
}

.insights-popup-logo {
  width: 170px;
  margin-bottom: 8px;
}

.insights-popup-description {
  margin: 0;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0.25;
  color: #2f2f2f;

  a {
    color: #005f63;
    font-weight: 700;
    text-decoration: none;
  }
}

.insights-popup-highlight {
  margin-top: 8px;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0;
  font-weight: 500;
  font-style: normal;
  color: #004F4F;
}

.insights-popup-subtitle {
  font-size: 12px;
  font-weight: 400;
  font-style: normal;
  line-height: 16px;
  color: #505353;
}

.insights-popup-feature {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0.25;
  font-size: 14px;
  line-height: 20px;
  color: #191C1C;

  a {
    color: #004F4F;
    font-weight: 700;
    text-decoration: none;
  }
}
</style>
